import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

// import axios from '../../config/axios';
import Header from '../Agency/components/Header/Header';
import SearchBar from '../../components/SearchBar/SearchBar';
import TableList from '../../pages/Agency/components/TableList/TableList';
import axios from 'axios';
import { get_agencies } from '../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        padding: 8
    },

    results: {
        marginTop: theme.spacing(3)
    }
}));


export default function Agency() {

    const classes = useStyles();

    const [agencies, setAgencies] = useState([]);

    useEffect(() => {
        let mounted = true;

        


        fetchAdmins();

        return () => {
            mounted = false;
        };
    }, []);

    const fetchAdmins = async () => {
        let data = await get_agencies();
        if (data) {
            setAgencies(data);
        }
    }
    const handleFilter = () => { };
    const handleSearch = () => { };

    return (
        <div
            className={classes.root}
            title="Agency Details"
        >
            <Header />
            {/* <SearchBar
                onSearch={handleSearch}
            /> */}
            {agencies && (
                <TableList
                    className={classes.results}
                    agencies={agencies}
                    refresh={fetchAdmins}
                />
            )}
        </div>
    )
}